import TSettingUserGroupsEdit from './index.vue';

TSettingUserGroupsEdit.install = app => {
  app.component(TSettingUserGroupsEdit.name, TSettingUserGroupsEdit);
};

export default TSettingUserGroupsEdit;
